import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNotificationH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M31.25 12.75a4.75 4.75 0 1 1 9.5 0V16h-2v-3.25a2.75 2.75 0 1 0-5.5 0V16h-2zm.618 45.75a4.252 4.252 0 0 0 8.264 0h-8.264m2.149-2h8.233v1a6.25 6.25 0 1 1-12.5 0v-1h4.267",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M53.75 56.5V34c0-9.665-7.835-17.5-17.5-17.5s-17.5 7.835-17.5 17.5v22.5zm-17.5-42c-10.77 0-19.5 8.73-19.5 19.5v24.5h39V34c0-10.77-8.73-19.5-19.5-19.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.75 57.5a1 1 0 0 1 1-1h48a1 1 0 1 1 0 2h-48a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }));
}
var IcNotificationH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotificationH72));

export { IcNotificationH72 as I };
